import VendorCard from './VendorCard';

export default VendorCard;
export type { VendorCardProps } from './VendorCard';
